import './css/style.css'
import './css/sidebar.css'
import './css/editDeviceModal.css'
import './css/calendarView.css'
import './css/settingsView.css'
import './css/smallScreen.css'
import './css/bigScreen.css'
import './css/themeStyle.css'
import './i18n'

import { useLayoutEffect } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import useLayoutStore from './store/useLayoutStore'
import { setupAxiosSessionInterceptor } from './auth/sessionLifecycle';

import '../src/socket/employeesSocket';

setupAxiosSessionInterceptor();

const ThemeBackground = () => {
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)
    const rootElement = document.querySelector('#root')

    useLayoutEffect(() => {
        if (isDarkTheme) {
            rootElement.classList.remove('white-theme-1');
            rootElement.classList.add('dark-theme-1');
        } else {
            rootElement.classList.remove('dark-theme-1');
            rootElement.classList.add('white-theme-1');
        }
    }, [isDarkTheme, rootElement])

    return null
}

const AppWithTheme = () => {
    return (
        <>
            <ThemeBackground />
            <App />
        </>
    )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <AppWithTheme />
)